import './back-to-top.scss';
import { execOnLoad } from '@general/helpers';
import { throttle } from 'lodash';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initBackToTop = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const container = sectionContainer.querySelector('.back-to-top__container');
  if (container) {
    const toggleBackToTop = () => {
      if (window.scrollY === 0) {
        container.classList.add('hidden');
      } else {
        container.classList.remove('hidden');
      }
    };

    toggleBackToTop();
    const throttledToggle = throttle(toggleBackToTop, 100);
    window.addEventListener('scroll', throttledToggle);
  }

  const button = sectionContainer.querySelector('.back-to-top__button');
  if (button) {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
};

execOnLoad(window.dAgency.initBackToTop, '.back-to-top__section');
